

// copy text to the clipboard
import toasts from './toast-notify';

function handleCopyText() {
	$('.copy-promotion-code').on('click',function(e) {
		e.preventDefault();
		var copyText = $(this).parent().find("#promotion-to-copy").val();
		navigator.clipboard.writeText(copyText);
		if($(this).parent().parent().hasClass("cart-promo-wrapper")) {
            toasts.init($('#clicktocopycode').val(), 'active animate__fadeInDownToast', 'icon icon-clickToCopy');
        } else {
			toasts.init(NOTIFICATION_SUCCESS_TEXT_COPY, 'active animate__fadeInDownToast', 'icon-clickToCopy');
		}
	})
	$('.copy-promotion-code .link-redirection').on('click',function(e) {
		$('.copy-promotion-code').trigger('click');
		setTimeout(() => {
			var baseurl = window.location.origin;
			var anchorUrl = baseurl+$('.copy-promotion-code .link-redirection').attr('href');
			window.location.replace(anchorUrl);
		}, 300);
	})
}

var copyTextToClipboard = {	
	init: function () {
        handleCopyText();
	}
};

export default copyTextToClipboard;